import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Autosuggest from 'react-autosuggest';
import { get } from 'lodash';
import { autocomplete } from '$api/postcode';
import styles from './index.module.scss';

const getSuggestionValue = (suggestion) => suggestion.name;

const renderSuggestion = (suggestion) => <div>{suggestion.name}</div>;

const isBackspaceKey = ({ key, keyCode }) => key === 'Backspace' || keyCode === 8;

export default class PostcodeAutocomplete extends Component {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  constructor(props) {
    super(props);
    this.state = {
      value: props.initialValue,
      suggestions: [],
      lastKeyDownBackspace: false, // don't autocomplete on Backspace
    };
  }

  onChange = (event, { newValue }) => {
    // eslint-disable-next-line react/destructuring-assignment
    this.setState({ value: newValue }, () => this.props.onChange(newValue));
  };

  onKeyDown = (event) => {
    this.setState({ lastKeyDownBackspace: isBackspaceKey(event) });
  };

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  onSuggestionsFetchRequested = ({ value }) =>
    // eslint-disable-next-line react/destructuring-assignment
    this.props.useAutocomplete &&
    autocomplete(value).then((res) => {
      const suggestions = (get(res, 'data.result') || []).map((postcode) => ({ name: postcode }));
      // eslint-disable-next-line react/destructuring-assignment
      if (suggestions.length === 1 && !this.state.lastKeyDownBackspace) {
        // autoselect if only one suggestion
        let suggestionName = '';
        this.setState(
          (state) => {
            suggestionName = get(suggestions, '0.name', state.value);
            return {
              suggestions: [],
              value: suggestionName,
            };
          },
          // eslint-disable-next-line react/destructuring-assignment
          () => this.props.onChange(suggestionName)
        );
      } else {
        this.setState({ suggestions });
      }
    });

  // Autosuggest will call this function every time you need to clear suggestions.
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  render() {
    const { value, suggestions } = this.state;
    const {
      header,
      postcodeError,
      uniqId,
      headerPlaceholder,
      className,
      inputRef,
      floating,
      label,
      placeholder,
      inputType,
      spellCheck,
    } = this.props;

    const headerInputProps = {
      placeholder: headerPlaceholder,
      name: 'postcode',
      value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      spellCheck,
    };

    const inputProps = {
      placeholder,
      name: 'postcode',
      value,
      type: inputType,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      spellCheck,
    };

    return (
      <div
        postcodeError={postcodeError}
        className={classNames(styles.PostcodeAutocomplete, floating && '-floating', className)}
      >
        <label className={classNames(styles.FloatingLabel, floating && '-show')}>{label}</label>
        <Autosuggest
          id={uniqId}
          ref={inputRef}
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={header ? headerInputProps : inputProps}
        />
      </div>
    );
  }
}

PostcodeAutocomplete.defaultProps = {
  onChange: () => undefined,
  postcodeError: '',
  header: false,
  useAutocomplete: false,
  uniqId: '',
  headerPlaceholder: '',
  className: '',
  inputRef: null,
  floating: false,
  label: '',
  placeholder: '',
  initialValue: '',
  inputType: 'text',
};

PostcodeAutocomplete.propTypes = {
  onChange: PropTypes.any,
  postcodeError: PropTypes.any,
  header: PropTypes.bool,
  useAutocomplete: PropTypes.bool,
  uniqId: PropTypes.string,
  inputType: PropTypes.string,
  headerPlaceholder: PropTypes.string,
  className: PropTypes.string,
  inputRef: PropTypes.object,
  floating: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  initialValue: PropTypes.string,
};
